export enum BulletsType {
    text,
    image,
}
